<template>
  <div class="home-node-list">
    <action-bar>
      <search placeholder="请输入节点名称" @onSearch="onSearch"></search>
      <el-button type="primary" @click="handleToHomeChart()">首页大屏</el-button>
      <div class="fill"></div>
      <el-select
        v-model="searchCriteria.f_like_id"
        class="org-selector"
        placeholder="请选择组织"
        clearable
      >
        <el-option v-for="item in orgArr" :key="item.id" :label="item.OrgName" :value="item.OrgId">
        </el-option>
      </el-select>
      <subscribe-block></subscribe-block>
    </action-bar>
    <common-bg-plate>
      <normal-table
        :table-data="tableData"
        :table-col="tableCol"
        :paging="paging"
        @pagination="getListFn"
      ></normal-table>
    </common-bg-plate>
  </div>
</template>

<script>
import subscribeBlock from '../components/subscribeBlock'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Index',
  components: {
    subscribeBlock
  },
  data() {
    return {
      showEdit: false,
      searchCriteria: {
        f_like_id: '',
        f_like_name: ''
      },
      tableCol: [
        {
          label: '节点id',
          prop: 'NodeId',
          minWidth: 503
        },
        {
          label: '组织节点IP和端口名称',
          prop: 'ipAndPort',
          minWidth: 232
        },
        {
          label: '节点角色',
          prop: 'Type',
          minWidth: 174
        },
        {
          label: '节点名称',
          prop: 'NodeName',
          minWidth: 176
        },
        {
          label: '所属组织',
          prop: 'OrgName',
          minWidth: 116
        }
      ],
      tableData: [],
      orgArr: [
        {
          value: 'org1',
          label: '组织1'
        },
        {
          value: 'org2',
          label: '组织2'
        },
        {
          value: 'org3',
          label: '组织3'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      paging: state => state.chain.chain_node_paging
    })
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getListFn()
        this.getOrgListFn()
      }
    }
  },
  mounted() {
    if (this.$store.state.home.chainCid) {
      this.getListFn()
      this.getOrgListFn()
    }
  },
  methods: {
    ...mapActions(['getChainNodeLists', 'getChainOrgLists']),
    handleToHomeChart() {
      this.$router.push('../dataAnalysis')
    },
    onSearch(val) {
      this.getListFn({
        name: val,
        orgId: this.searchCriteria.f_like_id
      })
    },
    getListFn(params = {}) {
      params.offset = params.offset || this.paging.offset
      params.limit = params.limit || this.paging.limit
      params.chainId = this.$store.state.home.chainCid

      this.getChainNodeLists({ ...params }).then(res => {
        this.tableData = res?.items || []
        this.tableData.forEach(item => {
          let ipAndPort = ''
          item.NodeIp && (ipAndPort = item.NodeIp)
          item.NodeRpcPort && (ipAndPort += ':' + item.NodeRpcPort)
          item.ipAndPort = ipAndPort
          item.Type = item.Type == 0 ? '共识节点' : '普通节点'
        })
      })
    },
    getOrgListFn(params = {}) {
      params.chainId = this.$store.state.home.chainCid
      params.limit = 1000
      this.getChainOrgLists(params).then(res => {
        this.orgArr = res.items
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('home-node-list', (), ());
.home-node-list {
  @include adaptation(
    (
      --home-node-list-search-width: 253px,
      --home-node-list-offset: 48px,
      --home-node-subscribe-margin-left: 24px
    )
  );
  --home-node-list-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--home-node-list-offset)
  );

  .cbaas-search-wrap {
    width: var(--home-node-list-search-width);
  }

  .home-subscribe {
    margin-left: var(--home-node-subscribe-margin-left);
  }

  .org-selector {
    /deep/ {
      .el-input__inner {
        height: var(--base-size-32);
        line-height: var(--base-size-32);
      }

      .el-input__icon { 
        line-height: var(--base-size-32);
      }
    }
  }

  .common-bg-plate {
    .normal-table-wrap {
      height: 100%;
      min-height: var(--home-node-list-min-height);

      /deep/ {
        .el-empty {
          height: 100%;
          min-height: var(--home-node-list-min-height);
        }

        .normal-table {
          height: 100%;
          min-height: var(--home-node-list-min-height);
        }
      }
    }
  }
}
</style>
